/**
 * Module dependencies.
 */

import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Query key.
 */

const KEY = 'cryptoGestAdmin';

/**
 * The admin-managed stablecoin symbol list.
 */

export function useCryptoGestStablecoins() {
  const client = useRequestProvider();

  return useQuery<string[]>([KEY, 'stablecoins'], {
    queryFn: async () =>
      client.get(resolveAppUrl('cryptoGestAdminStablecoins')).then(({ data }: any) => data?.data ?? [])
  });
}

/**
 * Add a stablecoin symbol.
 */

export function useAddCryptoGestStablecoin() {
  const client = useRequestProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (symbol: string) =>
      client.post(resolveAppUrl('cryptoGestAdminStablecoins'), { symbol }).then(({ data }: any) => data?.data),
    onSuccess: () => queryClient.invalidateQueries([KEY])
  });
}

/**
 * Remove a stablecoin symbol.
 */

export function useRemoveCryptoGestStablecoin() {
  const client = useRequestProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (symbol: string) =>
      client
        .delete(resolveAppUrl('cryptoGestAdminStablecoinBySymbol', { interpolations: { symbol } }))
        .then(({ data }: any) => data?.data),
    onSuccess: () => queryClient.invalidateQueries([KEY])
  });
}
